import React, { FC, useEffect, useState } from "react";
import * as Highcharts from "highcharts";
import { useNavigate } from "react-router-dom";
import { ExpensesData } from "@baseTypes/service/dashboard/IExpensesDashboardService";
import LinearChart from "../../../../components/modules/dashboards/сharts/defaultCharts/linearChart/LinearChart";
import PlanFactTooltip from "@modules/dashboards/dashboardTooltips/TooltipVariants/PlanFactTooltip/PlanFactTooltip";
import { Point } from "highcharts";
import { applyTip, shortMonthNames, wideFontSize24 } from "@utils/utils";
import { positionerWithOffset } from "@utils/highchart/tooltip";
import PlanFactLegend from "@elements/planFactLegend/PlanFactLegend";
import colors from "@infobis/ui-styles-utils/colors";

interface PlanFactChartType {
    listOfExpensesForExpensesDash: ExpensesData[]
}

window.Highcharts = Highcharts

const PlanFact: FC<PlanFactChartType> = (props) => {

    const navigate = useNavigate()
    let {
        listOfExpensesForExpensesDash
    } = props

    const [chartOptions, setChartOptions] = useState<Highcharts.Options>({ title: { text: '' } })

    function navigateByPoint(point: Point) {
        if (point) {
            const month = point.index + 1
            navigate(`expenses/${month}`)
        }
    }

    useEffect(() => {
            const defaultOptions: Highcharts.Options = {
                title: {
                    text: ''
                },
                legend: {
                    enabled: false,
                    align: 'center',
                    borderWidth: 0
                },
                credits: {
                    enabled: false
                },
                yAxis: {
                    type: "linear",
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            fontSize: wideFontSize24()
                        }
                    },
                    title: {
                        text: ''
                    },
                    alignTicks: true
                },
                xAxis: {
                    crosshair: true,
                    gridLineWidth: 1,
                    labels: {
                        style: {
                            fontSize: wideFontSize24(),
                            color: 'rgba(85, 87, 89, 1)',
                            fontWeight: '500'
                        }
                    },
                    categories: shortMonthNames,
                    lineColor: 'rgba(205, 206, 209, 1)',
                    tickColor: 'rgba(205, 206, 209, 1)'
                },
                tooltip: applyTip((ctx, tooltip) => PlanFactTooltip({
                    expenses: listOfExpensesForExpensesDash,
                    monthIndex: tooltip.chart.hoverPoint?.index
                }), {
                    shared: false,
                    positioner: positionerWithOffset({ x: 10 })
                }),
                plotOptions: {
                    spline: {
                        marker: {
                            radius: 4,
                            lineColor: '#666666',
                            lineWidth: 1
                        }
                    }
                },
                chart: {
                    events: {
                        click: function(e) {
                            navigateByPoint(this.series[0].searchPoint(e, true) as Point)
                        }
                    }
                },
                series: [
                    {
                        id: 'plan',
                        name: "План",
                        color: colors.ELEMENTS_CHARTS_13,
                        type: 'line',
                        data:  listOfExpensesForExpensesDash.length > 0 ? listOfExpensesForExpensesDash
                            .map((expenses: ExpensesData) => expenses.accumulative.byMonth.map((j) => j[0]))
                            .reduce((accum, item) => accum.map((i, index) => i + item[index])) : [],
                        events: {
                            click: (e) => navigateByPoint(e.point)
                        }
                    },
                    {
                        id: 'fact',
                        name: "Факт",
                        color: colors.ELEMENTS_CHARTS_15,
                        type: 'line',
                        data: listOfExpensesForExpensesDash.length > 0 ? listOfExpensesForExpensesDash
                            .map((i) => i.accumulative.byMonth.map((j) => j[1]))
                            .reduce((accum, item) => accum.map((i, index) => i + item[index])) : [],
                        events: {
                            click: (e) => navigateByPoint(e.point)
                        }
                    }
                ]
            }
            setChartOptions(defaultOptions)
    }, [listOfExpensesForExpensesDash])


    const [chartApi, setChartApi] = useState<Highcharts.Chart>()

    return <>
        <LinearChart
            callback={setChartApi}
            options={chartOptions}/>
        <PlanFactLegend chartApi={chartApi} padding={{ right: 10 }} />
    </>
}

export default PlanFact;






